import React, { FunctionComponent } from 'react'
import { Defs, LinearGradient, Path, Stop, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export const SearchStarIcon: FunctionComponent<SearchStarIconProps> = ({ size = 24, fillColor }) => {
  const { colors, isDarkMode } = useTheme()
  const { searchIcon } = colors.icons
  return (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
      <Path
        d='M10.5 2.75c.215 0 .429.011.64.028a5.025 5.025 0 00-.858 1.477A6.25 6.25 0 0010.5 16.75c3.38 0 6.13-2.682 6.244-6.033.543-.201 1.04-.493 1.477-.858a7.718 7.718 0 01-1.736 5.564l4.545 4.547a.75.75 0 11-1.06 1.06l-4.546-4.546A7.75 7.75 0 1110.5 2.75z'
        fill={fillColor || searchIcon.fill}
      />
      {!isDarkMode ? (
        <Path
          d='M10.644 6.575a.531.531 0 01-.015-.94c.886-.463 2.106-1.14 2.39-1.497.287-.362.947-1.636 1.4-2.535a.514.514 0 01.916.004c.47.951 1.167 2.316 1.408 2.53.235.21 1.58.84 2.553 1.282.396.179.4.753.012.946-.918.457-2.178 1.142-2.565 1.634-.376.477-.878 1.564-1.224 2.367a.523.523 0 01-.925.063c-.501-.843-1.228-2.033-1.576-2.43-.341-.39-1.513-1.005-2.374-1.424z'
          fill='url(#star_light_theme)'
        />
      ) : (
        <Path
          d='M10.6437 6.57507C10.2614 6.38908 10.2525 5.83089 10.6294 5.63414C11.5148 5.17194 12.7347 4.49537 13.0184 4.13783C13.3056 3.77592 13.9663 2.50154 14.4182 1.60326C14.6067 1.2286 15.1492 1.23052 15.3347 1.60664C15.8042 2.55834 16.5017 3.92295 16.7427 4.13783C16.9779 4.34749 18.3225 4.97676 19.2964 5.41859C19.6919 5.59801 19.6969 6.17202 19.308 6.36545C18.3905 6.82193 17.1298 7.50698 16.7427 7.99873C16.3673 8.4756 15.8647 9.56272 15.5187 10.3659C15.3527 10.7513 14.8078 10.7903 14.5936 10.4294C14.0929 9.58569 13.3659 8.39638 13.0184 7.99873C12.677 7.60805 11.505 6.99411 10.6437 6.57507Z'
          fill='url(#star_dark_theme)'
        />
      )}
      <Defs>
        <LinearGradient
          id='star_light_theme'
          x1={13.6384}
          y1={4.46996}
          x2={19.2623}
          y2={10.7968}
          gradientUnits='userSpaceOnUse'
        >
          <Stop stopColor='#F59324' />
          <Stop offset={1} stopColor='#E66F14' />
        </LinearGradient>

        <LinearGradient
          id='star_dark_theme'
          x1={13.3991}
          y1={2.64858}
          x2={17.0735}
          y2={9.28593}
          gradientUnits='userSpaceOnUse'
        >
          <Stop offset={0.178442} stopColor='#FFD971' />
          <Stop offset={0.906996} stopColor='#FF7700' />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

type SearchStarIconProps = {
  size?: string | number
  fillColor?: string
}
